import * as React from "react";

import { isValidNumber } from "utils/number";
import { CommentStarForWeb } from "../../../../components/CommentStar";
import { PoolExtraCollectInfo, ScoreOption } from "../../../../services/product";
import { InfoBottomView } from "./styles";
import { oneMoreWords } from "utils/string";

interface BottomViewsProps {
	columnNum: number;
	collect: PoolExtraCollectInfo;
	collectOptions?: ScoreOption;
}

export const BottomViews = (props: BottomViewsProps) => {
	const { collect, collectOptions = {} } = props;

	return (
		<InfoBottomView key={"bottomViews"}>
			{isValidNumber(collect?.score) ? (
				<>
					<CommentStarForWeb
						rateScore={+(collect?.score || 0)}
						settingOption={collectOptions}
					>
						{collectOptions?.widthScore && (
							<span style={{ color: "#999", fontSize: "12px", marginLeft: "3px" }}>
								{oneMoreWords(collect?.score?.toString())}
							</span>
						)}
					</CommentStarForWeb>
				</>
			) : null}
			{collect && <span>{collect?.text}</span>}
		</InfoBottomView>
	);
};
